export default {"src":"/_next/static/media/earlypaymentBackground.70429840.svg","height":525,"width":1366};